import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

const modules = require.context('./modules', true, /.js$/)
let moduleArr = []

modules.keys().map(key => {
	moduleArr[key.replace(/(\.\/)|(\.js)/ig, '')] = modules(key).default
})
Vue.use(Vuex); //vue的插件机制

//Vuex.Store 构造器选项
const store = new Vuex.Store({
	modules: {
		...moduleArr
	},
	getters
})
export default store
